// Import routing components
import AllRoutes from "./routes";
import "jquery";
import "../public/assets/css/allstyles.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min";
/* Many pages render OwlCarousel, react-datepicker and rc-slider without
   importing their stylesheets, and used to inherit them from a statically
   imported page. Route chunking took that away, so the entry has to carry them. */
import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";
import "react-datepicker/dist/react-datepicker.css";
import "rc-slider/assets/index.css";
import "rc-tooltip/assets/bootstrap.css";
/* confirmAlert() mounts on document.body from any route; its package CSS must
   ship from the entry bundle or the dialog renders unpositioned at page bottom. */
import "react-confirm-alert/src/react-confirm-alert.css";
import mapboxgl from "mapbox-gl";

import { createRoot } from "react-dom/client";

// Set here so lazy-loaded route chunks get a token regardless of import order.
mapboxgl.accessToken = process.env.MAPBOX_ACCESS_TOKEN;

const container = document.getElementById("root");
const root = createRoot(container);
root.render(<div>{AllRoutes()}</div>);
